import { Api } from './Api'

const ordersPathTo = {
  get: (id) => {
    return Api.request({
      url: '/orders/' + id + '.json',
      method: 'get',
      params: {
        with_items: 'true',
        with_logo: 'true'
      }
    })
  },
  save: (data) => {
    return Api.request({
      url: '/orders.json',
      method: 'post',
      data: data
    })
  },
  update: (id, data) => {
    return Api.request({
      url: '/orders/' + id + '.json',
      method: 'put',
      data: data
    })
  },
  delete: (id) => {
    return Api.request({
      url: '/orders/' + id + '.json',
      method: 'delete',
    })
  },
  list: (params) => {
    return Api.request({
      url: '/orders.json',
      method: 'get',
      params
    })
  },
  delivery_list: () => {
    return Api.request({
      url: '/orders/delivery_list.json',
      method: 'get',
    })
  },
  add_courier: (id, courier_id) => {
    return Api.request({
      url: '/orders/' + id + '/add_courier.json',
      method: 'put',
      data: {
        courier_id: courier_id
      }
    })
  },
  remove_courier: (id, courier_id) => {
    return Api.request({
      url: '/orders/' + id + '/remove_courier.json',
      method: 'put',
      data: {
        courier_id: courier_id
      }
    })
  },
  accept_order: (id) => {
    return Api.request({
      url: '/orders/' + id + '/accept_order.json',
      method: 'put',
      params: {
        with_items: 'true'
      }
    })
  },
  reject_order: (id) => {
    return Api.request({
      url: '/orders/' + id + '/reject_order.json',
      method: 'put',
      params: {
        with_items: 'true'
      }
    })
  },
  sales_list: () => {
    return Api.request({
      url: '/orders/sales_list.json',
      method: 'get',
      params: {
        with_items: 'true'
      }
    })
  },
  order_delivered: (id) => {
    return Api.request({
      url: '/orders/' + id + '/order_delivered.json',
      method: 'put',
      params: {
        with_items: 'true'
      }
    })
  },
  /** @deprecated Use order_delivered */
  order_shipped: (id) => ordersPathTo.order_delivered(id),
}

export default ordersPathTo